import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=75a28c84&"
import script from "./MainMenu.vue?vue&type=script&lang=ts&"
export * from "./MainMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports